module.exports = __webpack_public_path__ + "img/home2.6d3eef62.jpg";